import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ApiButtonsVisualization from './components/ApiButtonsVisualization';
import TeamsPage from './pages/TeamsPage';
import FixturesPage from './pages/FixturesPage';
import StandingsPage from './pages/StandingsPage';
import StatisticsPage from './pages/StatisticsPage';
import HeadToHeadPage from './pages/HeadToHeadPage';
import MatchDetailsPage from './pages/MatchDetailsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <ApiButtonsVisualization />
                <FixturesPage />
              </>
            } />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/standings" element={<StandingsPage />} />
            <Route path="/statistics" element={<StatisticsPage />} />
            <Route path="/h2h" element={<HeadToHeadPage />} />
            <Route path="/match/:fixtureId" element={<MatchDetailsPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
